import { ButtonTs } from '@lt/components';
import ArrowDown from '@lt/components/icons-react/rebrand/ChevronDown';
import type { ReactNode } from 'react';
import React from 'react';
import styled from 'styled-components';
import { TEST_ID_SORT_BTN } from './constants';

type Props = {
  onClick: () => void;
  children: ReactNode;
  className?: string;
};

export const ShowSortingButton = ({ children, onClick, className }: Props) => (
  <StyledButton
    onClick={onClick}
    data-testid={TEST_ID_SORT_BTN}
    className={className}
  >
    {children}
    <StyledArrowDown />
  </StyledButton>
);

const StyledButton = styled(ButtonTs).attrs({ variant: 'functional' })`
  padding: 12px;
  --background-color: var(--white);
  background-color: var(--background-color);
  border-radius: var(--border-radius);

  transition: 0.1s ease-in-out;

  white-space: pre;
  color: var(--black);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;

  &:active {
    background: linear-gradient(
        0deg,
        rgba(0, 0, 0, var(--pressed-alpha)) 0%,
        rgba(0, 0, 0, var(--pressed-alpha)) 100%
      ),
      var(--background-color);
  }
`;

const StyledArrowDown = styled(ArrowDown)`
  margin-left: 6px;
  height: 12px;
`;
